import { createAsyncAction } from 'typesafe-actions';
import { FailureActionPayload } from '../errors/types';

export const openAuthFlow = createAsyncAction(
  'OPEN_AUTH_FLOW_REQUEST',
  'OPEN_AUTH_FLOW_SUCCESS',
  'OPEN_AUTH_FLOW_FAILURE',
)<void, string, FailureActionPayload>();
